require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-calculators-how-can-i-save-for-a-big-ticket-item.json") })
        }
      }, "path---es-calculators-how-can-i-save-for-a-big-ticket-item");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-calculators-how-can-i-save-for-a-big-ticket-item!./.cache/json/es-calculators-how-can-i-save-for-a-big-ticket-item.json
// module id = 2505
// module chunks = 231608221292675